function InputLabel({id, title, required, error}) {
    return (
        <>
            <label htmlFor={id}
                   className="peer-focus:font-medium absolute text-sm text-primary duration-300 transform
                   -translate-y-6 scale-75 top-3 z-10 origin-[0] peer-focus:left-0 peer-focus:text-primary
                   peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75
                   peer-focus:-translate-y-6">
                {title}{required ? "*" : ""}
            </label>
            {error ?
                (
                    <p className="mt-0 text-xs text-red-600 font-medium">{error}</p>
                )
                : ""}
        </>
    );
}

export default InputLabel;